import React from "react";
import {Text} from "react-native";
import {TransactionHistory} from "../../generated/smg_service_pb";
import MainStyle from "../../MainStyle";
import moment from 'moment';
import {formatCurrency} from "../utils";
import Div from "../lib/Div";
import {isFullSwing} from "../constants";
import {colors} from "../assets/styles/colors";
import P from "../lib/P";
import {getTransactionHistoryStatusPresentation} from "../utils/transactionHistoryStatus";

type Props = { item: TransactionHistory };

const TransactionHistoryItem = (props: Props) => {
  const {item} = props;
  // @ts-ignore
  const num = item.i;
  const statusPresentation = getTransactionHistoryStatusPresentation(item, isFullSwing);

  return (
    <Div row bg={isFullSwing ? 'transparent' : colors.bottomTabBg} borderWidth={isFullSwing ? 0 : 1} alignItems="center"
         borderColor={colors.blueText} mb={isFullSwing ? 0 : 4} rounded={isFullSwing ? 0 : 4} position="relative"
         h={55}>
      {isFullSwing ? (
        <>
          <Div w={190} row alignItems="center">
            <P w={45} ta="center" fontFamily="DavisSans-Regular" fs={13}>{num}</P>
            <Div ml={10} flex={1}>
              <P fontFamily="DavisSans-Regular" fs={14}>{item.type}</P>
              <P fontFamily="DavisSans-Regular" fs={10} color="#BBBCBF">
                {moment.unix(Number(item.time)).format('L')} {moment.unix(Number(item.time)).format('LT')}
              </P>
            </Div>
          </Div>

          <P flex={1} ta="center" fontFamily="DavisSans-Regular">{formatCurrency(Number(item.amount) / 100)}</P>

          <Div w={90}>
            <P ta="center" fontFamily="DavisSans-Medium" fs={13} style={statusPresentation.style}>
              {statusPresentation.label}
            </P>
            <P ta="center" fontFamily="DavisSans-Regular" fs={10} color="#BBBCBF">
              {moment.unix(Number(item.lastUpdateTime)).format('L')}
            </P>
            <P ta="center" fontFamily="DavisSans-Regular" fs={10} color="#BBBCBF">
              {moment.unix(Number(item.lastUpdateTime)).format('LT')}
            </P>
          </Div>
        </>
      ) : (
        <>
          <Div column flex={1}>
            <Text style={styles.index_s}>{num}</Text>
            <Text style={styles.index_s}>{moment.unix(Number(item.time)).format('ll')}</Text>
            <Text style={styles.index_s}>{moment.unix(Number(item.time)).format('LT')} PT</Text>
          </Div>

          <Text style={styles.type_s}>{item.type}</Text>

          <Text style={styles.amount_s}>{formatCurrency(Number(item.amount) / 100)}</Text>

          <Div column flex={1}>
            <Text style={[...styles.status_s, statusPresentation.style]}>
              {statusPresentation.label}
            </Text>

            <Text style={styles.status_s}>
              {moment.unix(Number(item.lastUpdateTime)).format('ll')}
            </Text>

            <Text style={styles.index_s}>
              {moment.unix(Number(item.lastUpdateTime)).format('LT')} PT
            </Text>
          </Div>
        </>
      )}

      {isFullSwing && <Div h={1} position="absolute" bottom={0} left={16} right={0} bg="#BBBCBF" opacity={0.15}/>}
    </Div>
  );
};

const styles = {
  index_s: [MainStyle.f_w_700, MainStyle.f_s_10, MainStyle.l_h_14, MainStyle.t_a_c, MainStyle.c_white],
  type_s: [MainStyle.f_w_700, MainStyle.f_s_10, MainStyle.l_h_14, MainStyle.t_a_c, MainStyle.c_white, MainStyle.flex1],
  amount_s: [MainStyle.flex1, MainStyle.f_w_700, MainStyle.f_s_10, MainStyle.l_h_55, MainStyle.t_a_c, MainStyle.c_white],
  status_s: [MainStyle.f_w_700, MainStyle.f_s_10, MainStyle.l_h_14, MainStyle.t_a_c, MainStyle.c_white],
};

export default React.memo(TransactionHistoryItem);
